import { CR_FILTER_EVENT, CrFilterEvent } from '../../../customer-review-star-filter/client/customer-review-star-filter.component';
import { isSortParameter } from '../../types';
import { reloadReviewList } from './reload-review-list';
import { setUrlSearchParam } from '../../../_common/client/set-url-search-param';
import { removeUrlSearchParam } from '../../../_common/client/remove-url-search-param';
import { updateCurrentPageInHtml } from './pagination/update-current-page-in-html';
import { scrollPageToReviews } from './scroll-page-to-reviews';
import { enableOrDisablePaginationButtons } from './pagination/enable-or-disable-pagination-buttons';
import { updateLastPageInHtml } from './pagination/update-last-page-in-html';
import { WindowLocation } from '../../../_common/client/window-location';

export const registerOnFilterEvent = (listWrapperRootElement: HTMLElement) => {
    o_global.eventQBus.on(CR_FILTER_EVENT, async (eventData: CrFilterEvent) => {
        setUrlSearchParam('filter', eventData.filter);
        removeUrlSearchParam('page');
        updateCurrentPageInHtml(1, listWrapperRootElement);
        updateLastPageInHtml(eventData.filter, listWrapperRootElement);
        enableOrDisablePaginationButtons(1, listWrapperRootElement);
        await reloadReviewList(listWrapperRootElement, eventData.filter, readSortParameterFromUrl());
        scrollPageToReviews(listWrapperRootElement);
    });
};

const readSortParameterFromUrl = () => {
    const sortParameterSearchParam = new URLSearchParams(WindowLocation.getSearch()).get('sort');
    return sortParameterSearchParam && isSortParameter(sortParameterSearchParam) ? sortParameterSearchParam : undefined;
};
